
export interface AuthentificationConfig {
  externalAuth?: ExternalAuthConfig;
  doubleAuth?: DoubleAuthConfig;
  passwordRules?: passwordRulesConfig;
}

///////// Open Id Stuff /////////
type OpenIdButtonType = 'image-only' | 'icon+label' | 'label-only';
type OpenIdAlgo = 'HS256' | 'RS256';

export const OIDC_LOGIN_CALLBACK_PATH: Array<string> = ['oidc-authorize', 'oidc-login-callback', 'login-callback', 'test-callback-login']
export const OIDC_LOGOUT_CALLBACK_PATH: Array<string> = ['oidc-logout', 'oidc-logout-callback', 'logout-callback', 'test-callback-logout']

export interface ExternalAuthConfig {
  isActive: boolean;
  providers: OidcProvider[]

}

export interface OidcProvider {
  providerId: string;

  isActive: boolean;
  providerName: string;
  providerType: string;
  displayOrder: number;

  providerLogo: string;
  providerButtonType: OpenIdButtonType; // 'image-only' | 'icon+label' | 'label-only'
  providerButtonImage: string;
  providerButtonHoverImage: string;
  providerButtonImageDark: string;
  providerButtonHoverImageDark: string;

  providerButtonIcon: string;
  providerButtonLabel: string;

  clientId: string;
  clientSecret: string;

  useAutoDiscover: boolean;
  urlDiscovery: string;
  suggestedDiscoveryUrls: { label: string, url: string }[],

  urlAuthorization: string;
  urlToken: string;
  urlUserInfo: string;
  urlLogout: string;

  useJwksUrl: boolean;
  urlJwks: string;

  issuer: string;

  signatureKeys: oidcSignatureKey[] // to store keys from JWKS url (from backend)


  signatureHS256Secret: string; // only for  HS256
  signatureRS256PublicKey: string; // for RS256 without JWKS

  idTokenSignatureAlgo: OpenIdAlgo; // 'HS256' or 'RS256'
  supportedIdTokenSignatureAlgo: string[];

  userInfoSignatureAlgo: string;
  supportedUserInfoSignatureAlgo: string[];

  timeControlTolerance: number;

  scopes: string;
  supportedScopes: oidcScope[];

  accountReconciliationMethod: string;

  disconnectProviderAtLogout: 'yes' | 'no' | 'userChoice'

  msgHeader: string;
  linkInfoLabel: string;
  linkInfoUrl: string;

  msgNoUserFound: string;
}

export interface oidcSignatureKey {
  kid: string,
  algo: string,
  publicKey: string
}

export interface oidcScope {
  name: string;
  label: string;
  hint: string;
  required?: boolean
  custom?: boolean
}


export type oidcMessageType = 'infoUserNotFound' | 'error';
export type oidcVariablesForMessage = {
  fournisseurIdentite: string;
  civilitePrenomNom?: string;
}
export type oidcMessage = {
  providerId: string;
  type: oidcMessageType;
  message: string;
  variables?: oidcVariablesForMessage;
  errorLink?: string;
  canCreateAccount?: boolean;
}


///////// Double Auth Stuff /////////
export interface DoubleAuthConfig {
  isActive: boolean;

  serviceName: string;

  delay: any;

  restrictGED: boolean;
  restrictSEPA: boolean;
  restrictFactures: boolean;

  msgDescriptionBeforeActivation: string;
  msgDescriptionAfterActivation: string;
  msgHelpActivation: string;
  msgHelpUtilisation: string;
  msgRestrictedArea: string;
}

export interface passwordRulesConfig {
  minPasswordLength: number;
  minPasswordStrength: number;
};
